<template>
  <div>
    <v-layout class="pull-left">
      <v-dialog :modelValue="show" max-width="450px" @keydown.esc="$emit('close')" @click:outside="$emit('close')">
        <v-card>
          <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="print">

            <v-card-title style="margin-bottom: px !important">
              <span class="headline">Imprimir Etiqueta ASN</span>
            </v-card-title>

            <v-card-text class="mt-4">
              <v-text-field label="Cantidad*" name="amount" v-model="item.amount"
                :rules="[rules.required, rules.max100Amount]" :disabled="disabled"></v-text-field>

              <v-combobox v-model="item.measure" name="measure" item-title="name" item-value="id"
                :items="measures" label="Medidas de papel*" autocomplete="off"
                :rules="[rules.requiredComboBox]"></v-combobox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="$emit('close')">Cancelar</v-btn>
              <v-btn color="success" text type="submit" :loading="loading_imprimir">Imprimir</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";
import { asnService } from "@/libs/ws/asnService";

export default {
  props: {
    show: Boolean,
    close: Function,
    asn: Object,
  },
  name: "ModalPrintAsn",
  mixins: [ValidMixin],
  created() { },
  data() {
    return {
      loading_imprimir: false,
      format_page: "pdf",
      item: {
        amount: 1,
        measure: {id:2, name: "10x5"},
      },
      defaultItem:  {
        amount: 1,
        measure: {id:2, name: "10x5"},
      },
      measures: [{id: 1, name: "10x15"}, {id:2, name: "10x5"}]
    };
  },
 
  watch: {
    show() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    print() {
      if (this.loading) return;

      if (this.valid && this.asn) {
        var params = {
          asn_id: this.asn.id,
          measure: this.item.measure != null ? this.item.measure.id : null,
          amount: this.item.amount
        };

        this.loading_imprimir = true;

        asnService.printLabel(params, this.format_page).then((response) => {
          try {
            //Transformo a string la respuesta para poder enviar mensajes de error.
            let result = JSON.parse(this.arrayBufferToString(response.data));
            if (!result.status) {
              this.toast.error(result.msg);
            }
          } catch (e) {
            let blob;
            let link;
            switch (response.headers["content-type"]) {
              case "application/pdf":
              case "text/html; charset=UTF-8":
                blob = new Blob([response.data], {
                  type: "application/pdf",
                });
                link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.target = "_blank";
                link.click();
                break;
              case "application/zip":
                blob = new Blob([response.data], {
                  type: "application/zip",
                });
                link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.target = "_blank";
                link.download = "Etiquetas_ASN.zip";
                link.click();
                break;
              case "text/plain; charset=UTF-8":
                blob = new Blob([response.data], {
                  type: "text/plain",
                });
                link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.target = "_blank";
                link.download = "ASN_" + this.asn.id + ".txt";
                link.click();
                break;
            }
          }
          this.loading_imprimir = false;
          this.item = JSON.parse(JSON.stringify(this.defaultItem));
          this.$emit("close");
        }).catch((error) => {
          console.log("Error en printLabel:", error);
          console.log("Error response:", error.response);
          this.loading_imprimir = false;
          this.toast.error("Error al imprimir la etiqueta");
        });
      }
    },
    arrayBufferToString(buffer) {
      var arr = new Uint8Array(buffer);
      var str = String.fromCharCode.apply(String, arr);
      if (/[\u0080-\uffff]/.test(str)) {
        throw new Error(
          "this string seems to contain (still encoded) multibytes"
        );
      }
      return str;
    },
  },
};
</script>
